import styled, { css } from 'styled-components'
import { Tooltip } from '@sketch/components'

export const StyledDocumentCardIcons = styled.div`
  position: relative;
  top: 2px;

  height: 0px; /* This ensures the icons do not add extra height to the line */

  display: inline-flex;
  align-items: center;
`

export const StyledTooltip = styled(Tooltip)`
  display: flex;
  padding: 0 2px; /* stylelint-disable-line scales/space */
`

export const StyledIcon = styled.svg.attrs({
  role: 'img',
})(
  ({ theme: { colors } }) => css`
    width: 17px;
    height: 17px;

    /* This color should be "Light/colors.foreground.secondary.4" but given the icon composition */
    /* Opacity needs to be applied to the whole object */
    color: ${colors.foreground.secondary.A};
    opacity: 0.55;
  `
)
